/* global wpApiSettings */
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { wpBase } from "../store/api/base";
import { ColorRing } from "react-loader-spinner";
import { deleteImg } from "../store/thunks/vendorsThunks";

const ReplyToListing = ({ onReply }) => {
  const [message, setMessage] = useState("");
  const [attachmentUrl, setAttachmentUrl] = useState(null);
  const [preview, setPreview] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isDelImgLoading, setIsDelImgLoading] = useState(false);
  const [error, setError] = useState("");
  const [imgId, setImgId] = useState(null);
  const { carDetails: listingId, formId } = useSelector(
    (state) => state.details
  );
  const dispatch = useDispatch();

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      setIsLoading(true);
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result);
      };
      reader.readAsDataURL(file);

      // Upload the file immediately
      try {
        const formData = new FormData();
        formData.append("parent_model", "message");
        formData.append("parent_field", "attachment");
        formData.append("parent", formId);
        formData.append("render", "true");
        formData.append("_wpnonce", wpApiSettings.nonce);
        formData.append("file", file);

        const response = await wpBase.post(
          "/wp-json/hivepress/v1/attachments/",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              "X-WP-Nonce": wpApiSettings.nonce,
            },
          }
        );

        if (response.data.file_url) {
          setAttachmentUrl(response.data.file_url); // Store the URL or reference to the file
        } else if (response.data.file_content) {
          // Handle binary data if needed
          const binaryData = atob(response.data.file_content);
          const blob = new Blob([binaryData], { type: "image/jpeg" }); // Adjust MIME type if needed
          const url = URL.createObjectURL(blob);
          setAttachmentUrl(url);
        }
        setImgId(response?.data?.data?.id);
        setError("");
      } catch (error) {
        setError("Error uploading file.");
      } finally {
        setIsLoading(false);
      }
    } else {
      setPreview("");
      setAttachmentUrl(null);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onReply({ listingId: listingId?.id, message, attachment: attachmentUrl });
    setMessage("");
    setAttachmentUrl(null);
    setPreview("");
  };

  const handleRemove = () => {
    setIsDelImgLoading(true);
    const deleteImgAsync = async () => {
      try {
        const response = await dispatch(deleteImg({ imgId })).unwrap(); // Pass { imgId } as an object
        setPreview("");
      } catch (error) {
        console.error("Failed:", error);
      } finally {
        setIsDelImgLoading(false);
      }
    };
    deleteImgAsync();
  };

  return (
    <div className="form-container">
      <form onSubmit={handleSubmit} className="form">
        <div className="form-fields">
          <div className="form-field">
            <label className="form-label">
              <span>Message</span>
            </label>
            <textarea
              name="text"
              placeholder="Type a Message"
              maxLength="2048"
              required
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              className="form-textarea"
            ></textarea>
          </div>
          <div className="form-field">
            <label className="form-label">
              <span>Attachment</span> <small>(optional)</small>
            </label>
            <div className="attachment-upload">
              <label htmlFor={`attachment_${listingId?.id}`}>
                <button type="button" className="button">
                  <span>Select File</span>
                </button>
                <input
                  type="file"
                  name="attachment"
                  id={`attachment_${listingId?.id}`}
                  accept=".jpg,.jpeg,.png,.gif"
                  onChange={handleFileChange}
                  className="file-input"
                />
              </label>
              {preview && (
                <div className="image-preview">
                  <div className="loader">
                    <ColorRing
                      visible={isLoading || isDelImgLoading}
                      height="60"
                      width="60"
                      ariaLabel="color-ring-loading"
                      wrapperStyle={{}}
                      wrapperClass="color-ring-wrapper"
                      colors={[
                        "#e15b64",
                        "#f47e60",
                        "#f8b26a",
                        "#abbd81",
                        "#849b87",
                      ]}
                    />
                  </div>
                  <img
                    src={preview}
                    alt="Attachment Preview"
                    style={{
                      maxWidth: "100%",
                      height: "auto",
                      border: "1px solid #ddd",
                      borderRadius: "4px",
                      opacity: `${isLoading || isDelImgLoading ? "0.3" : "1"}`,
                    }}
                  />

                  {isDelImgLoading ? (
                    <span className="deleting-img">Deleting...</span>
                  ) : (
                    !isLoading && <button onClick={handleRemove}>Remove</button>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="form-footer">
          <button className="submit-button" type="submit" disabled={isLoading}>
            <span>Send</span>
          </button>
        </div>
        {error && <p style={{ color: "red" }}>{error}</p>}
      </form>
    </div>
  );
};

export default ReplyToListing;
